import React, { useState } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

const DateContext = React.createContext({})
DateContext.displayName = 'DateContext'
export default DateContext

const DateStore = ({ children }) => {
  const [get, set] = useState({ start: moment.utc(), end: moment.utc() })
  return (
    <DateContext.Provider value={{ get, set }}>
      {children}
    </DateContext.Provider>
  )
}
DateStore.propTypes = { children: PropTypes.node.isRequired }
export { DateStore }
